<h1 class="page-title mb-5"> تكافؤ الفرص </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="content-wrapper">
                    <h3 class="fw-bold mb-3 section-title">مفهوم تكافؤ الفرص</h3>
                    <p class="mb-4">
                        تحقيق المساواة بين كافة فئات المجتمع من خلال إتاحة الفرص بشكل عادل لكل الفئات للمشاركة في كل
                        المجالات الاقتصادية والاجتماعية والسياسية دون أي تمييز.
                    </p>

                    <h3 class="fw-bold mb-3 section-title">المواد / والبنود الموضحة لمبدأ تكافؤ الفرص</h3>

                    <p class="mb-4">
                        نص <span class="fw-bold text-decoration-underline">الدستور المصري في المادة رقم (53) على</span>
                        رفض كافة أشكال التمييز بين المواطنين، واعتبره جريمة يُعاقب عليها القانون وألزم الدولة باتخاذ
                        التدابير اللازمة للقضاء على كافة أشكاله.
                    </p>

                    <p class="mb-4">
                        يتعلق <span class="fw-bold text-decoration-underline">الهدف الخامس من أهداف التنمية
                            المستدامة</span>
                        بالمساواة بين الجنسين وهو أحد أهداف التنمية المستدامة السبعة عشر التي وضعتها الأمم المتحدة في
                        عام 2015. والذي ينص على تحقيق المساواة بين الجنسين وتمكين جميع النساء والفتيات وأن التنمية يجب
                        أن توازن بين الاستدامة الاجتماعية والاقتصادية والبيئية حيث صُممت أهداف التنمية المستدامة للقضاء
                        على العديد من المشاكل التي يواجهها العالم، بما في ذلك الفقر والجوع ومنح النساء والفتيات حقوقًا
                        متساوية، وفرضًا للعيش بحرية دون تمييز ونبذ العنف ضدها.
                    </p>

                    <p class="mb-4">
                        كما يتعلق <span class="fw-bold text-decoration-underline">الهدف العاشر من اهداف التنمية
                            المستدامة</span>
                        بتحقيق العدالة الاجتماعية والحد من عدم المساواة اذ ان عدم المساواة يمكن أن يكون تهديدا خطيرا
                        للاستقرار الاجتماعي والسياسي كما انها قد تعوق تحقيق الأهداف الاقتصادية الشاملة.
                    </p>

                    <p class="mb-5">
                        تقوم <span class="fw-bold text-decoration-underline">رؤية مصر 2030</span> على ترسيخ قيم العدالة
                        والمساواة، وإعمالاً لما جاء به من مبادئ تكافؤ الفرص، وما كفله للمرأة من حقوق، واتساقاً مع رؤية
                        مصر 2030 واستراتيجيتها للتنمية المستدامة التي تسعى لبناء مجتمع عادل، يضمن الحقوق والفرص
                        المتساوية
                        لأبنائه وبناته من أجل أعلى درجات الاندماج الاجتماعي لكافة الفئات، وإيماناً من الدولة المصرية،
                        بأن الاستقرار والتقدم لن يتحققا إلا من خلال ضمان مشاركة فاعلة للمرأة في كافة أوجه العمل الوطني،
                        وتفعيل الخطط والبرامج والمشروعات المتضمنة في هذه الاستراتيجية.
                    </p>

                    <h3 class="fw-bold mb-3 section-title">دور الهيئة العامة للاستثمار في مجال دعم تكافؤ الفرص</h3>
                    <p class="mb-4">
                        قامت الهيئة باستحداث الإدارة المركزية للمسئولية المجتمعية والتي تتضمن إدارة عامة تحت مسمي (
                        تكافؤ
                        الفرص) التي تعمل على نشر الوعي بمفهوم تكافؤ الفرص داخليا لتعزيز تطبيق المساواة بين الجنسين من
                        الموظفين والموظفات بالهيئة العامة للاستثمار وخارجيا لتعزيز تطبيق المفهوم في الشركات ومجتمع
                        الاعمال وذلك من خلال تنظيم الندوات وورش العمل والفعاليات والمبادرات المختلفة والأنشطة وإعداد
                        البروتوكولات مع كافة الجهات الداخلية والخارجية التي تعزز وتضمن تحقيق الأهداف وتمكين النوع
                        الاجتماعي والفئات المستهدفة وفقا للتوجه الاستراتيجي للدولة واحتياجات التنمية المستدامة بها.
                    </p>
                </div>
            </div>

            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>